import { ReactNode } from 'react'
import { FinderCreateContext, FinderCreateSlot } from '../types'

export function resolveFinderCreateSlot(slot: FinderCreateSlot | undefined, ctx: FinderCreateContext): ReactNode {
    if (!slot) return null
    return typeof slot === 'function' ? slot(ctx) : slot
}
